










import { Component, Vue } from 'vue-property-decorator';

import FlagshipProfilingStepBudgetVideoViewModel
  from '@/vue-app/view-models/components/flagship/flagship-profiling/flagship-profiling-step-budget-video-view-model';

@Component({
  name: 'FlagshipProfilingStepIntroductionVideo',
  components: {
    FlagshipProfilingVideo: () => import('@/vue-app/components/flagship/flagship-profiling/FlagshipProfilingVideo.vue'),
  },
})
export default class FlagshipProfilingStepIntroductionVideo extends Vue {
  flagship_budget_video_view_model = Vue.observable(
    new FlagshipProfilingStepBudgetVideoViewModel(this),
  );
}
